import { useState, useEffect } from 'react'
import DashboardMultiSelect from '../../../GlobalComponents/_misc/DashboardMultiSelect'
import { SalesReportArea, SalesDivision } from '../../../features/salesperson/salespersonAPI'

interface SalesDivisionMultiSelectProps {
    data: SalesDivision[]
    selectedSalesReportAreas: SalesReportArea[]
    selectedValues: SalesDivision[]
    onSelectedValuesChanged(selectedValues: SalesDivision[]): void
}

const SalesDivisionMultiSelect = (props: SalesDivisionMultiSelectProps) => {
    const [salesDivisions, setSalesDivisions] = useState<SalesDivision[]>([])
    const [selectedSalesReportAreas, setSelectedSalesReportAreas] = useState<SalesReportArea[]>([])
    const [selectedValues, setSelectedValues] = useState<SalesDivision[]>([])

    useEffect(() => {
        // Only keep divisions that exist in selected Sales Teams/Report Group/Report Area list
        const newSelectedValues = selectedValues.filter((ra) =>
            props.selectedSalesReportAreas.some(
                (group) =>
                    group.Team === ra.Team &&
                    group.ReportGroup === ra.ReportGroup &&
                    group.ReportArea === ra.ReportArea
            )
        )
        if (newSelectedValues.length !== selectedValues.length) onChange(newSelectedValues)

        const getUnique = (arr: any[], props: string[] = []) => [
            ...new Map(arr.map((entry) => [props.map((k) => entry[k]).join('|'), entry])).values(),
        ]

        // Get unique divisions that exist in selected Report Areas list
        const divData = getUnique(
            [
                ...new Set(
                    props.data
                        .filter((sg) =>
                            props.selectedSalesReportAreas.some(
                                (ra) =>
                                    sg.Team === ra.Team &&
                                    sg.ReportGroup === ra.ReportGroup &&
                                    sg.ReportArea === ra.ReportArea
                            )
                        )
                        .map((ra) => ({
                            Team: ra.Team,
                            ReportGroup: ra.ReportGroup,
                            ReportArea: ra.ReportArea,
                            Division: ra.Division,
                        }))
                ),
            ],
            ['Team', 'ReportGroup', 'ReportArea', 'Division']
        )

        setSalesDivisions(divData)

        // // If report area is newly-added, select all of its divisions - should be new to data
        // const newReportAreas = props.selectedSalesReportAreas.filter(
        //     (sra) =>
        //         !selectedSalesReportAreas.some(
        //             (ssra) =>
        //                 sra.Team === ssra.Team &&
        //                 sra.ReportGroup === ssra.ReportGroup &&
        //                 sra.ReportArea === ssra.ReportArea
        //         )
        // )
        // if (newReportAreas.length > 0) {
        //     const newDivData = divData.filter((vp) =>
        //         newReportAreas.some(
        //             (div) =>
        //                 div.Team === vp.Team &&
        //                 div.ReportGroup === vp.ReportGroup &&
        //                 div.ReportArea === vp.ReportArea
        //         )
        //     )
        //     onChange([...selectedValues, ...newDivData])
        // }
        setSelectedSalesReportAreas(props.selectedSalesReportAreas)
    }, [props.selectedSalesReportAreas])

    const onChange = (value: SalesDivision[]) => {
        setSelectedValues(value)
        props.onSelectedValuesChanged(value)
    }

    return (
        <DashboardMultiSelect
            data={salesDivisions}
            keyField="Division"
            textField="Division"
            selectedValues={selectedValues}
            onSelectedValuesChanged={onChange}
        />
    )
}

export default SalesDivisionMultiSelect
